import React from "react";

const FEATURES = {
    ai_analysis: false,
    analytics: false,
    patient_level_information: false,
    user_worklist: false
};

// FeatureProvider wraps the app and passes features via context
const FeatureContext = React.createContext(FEATURES);

export const FeatureProvider = ({ features, children }) => {
    const mergedFeatures = { ...FEATURES, ...(features || {}) };
    return (
        <FeatureContext.Provider value={mergedFeatures}>
            {children}
        </FeatureContext.Provider>
    );
};

export const FeatureGate = ({ feature, children }) => {
    const features = React.useContext(FeatureContext);
    if (features[feature]) {
        return <>{children}</>;
    }
    return null;
};